import React, { Component } from 'react';
import QueryString from 'query-string';
import { Redirect } from 'react-router-dom';
import { Row, Col, Modal, Button } from 'react-bootstrap';

import { Http } from '../../../../support';
import TransferInformation from './TransferInformation';
import LoadingButton from '../../../../facturotopia/LoadingButton';
import ResponseError from '../../../../shared/responses/ResponseError';

class BuyPackageUsingTransfer extends Component {
  state = {};

  componentWillUnmount() {
    this.setState = () => {}
  }

  handleOnClose = () => {
    this.props.history.replace('/cuenta/paquetes');
  }

  handleOnPaymentWithTransfer = async () => {
    const { pk } = this.props.match.params;

    const query = QueryString.parse(this.props.location.search);

    const licencia = query.licencia || 'm';

    const param = {
      paquete: {
        id: pk,
        licencia: licencia
      }
    };

    this.setState({
      busy: true,
    });

    try {
      const response = await Http.post(`api/paquetes/${pk}/transferencia`, param);

      this.setState({
        result: response
      });

    } catch (response) {
      this.setState({
        error: response.data || response
      });
    } finally {
      this.setState({
        busy: false
      });
    }
  }

  renderError = () => {
    const { error } = this.state;

    error.message = 'Algo pasó con el paquete que intentas comprar, intenta con otro.';

    return (
      <div className="result-container">
        <ResponseError
          title="Falló el registro de compra"
          error={ error }
          onAction={ this.handleOnAction }
        />
      </div>
    );
  }

  handleOnAction = (action) => {
    if (action === 'reset') {
      this.props.history.replace('/cuenta/paquetes');
    }
  }

  render() {
    const { error, busy, result } = this.state;

    if (result) {
      let { from } = { from: { pathname: '/cuenta/paquetes/' } };

      const search = this.props.location.search;

      let to = { pathname: `/cuenta/historial-compra/${result.compra}/info`, search: search };

      return <Redirect to={ to } state={ from } />;
    }

    if (error) {
      return this.renderError();
    }

    return (
      <Modal backdrop="static" keyboard={ false } show={ true } centered={ true } onHide={ this.handleOnClose }>
        <Modal.Header closeButton>
          <Modal.Title>
            Pago con transferencia
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col>
              <TransferInformation />
            </Col>
          </Row>

          <Row className="mt-3">
            <Col>
              <Button type="button"
                variant="secondary"
                onClick={ this.handleOnClose }
              >
                Cancelar
              </Button>
            </Col>

            <Col className="text-right">
              <LoadingButton type="button"
                variant="primary"
                disabled={ busy }
                loading={ busy || false }
                onClick={ this.handleOnPaymentWithTransfer }
              >
                { !!busy ? 'Procesando...' : 'Continuar'}
              </LoadingButton>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    )
  }
}

export default BuyPackageUsingTransfer;
